<template>
  <div class="c-w-100">
    <div class="my-4" v-if="showTitle">
      <b-skeleton height="20px" width="300px" :animated="true"></b-skeleton>
      <b-skeleton height="20px" width="200px" :animated="true"></b-skeleton>
    </div>
    <div class="columns">
      <div class="column" v-for="item, index in firstBox" :key="index">
        <b-skeleton height="70px" :animated="true"></b-skeleton>
      </div>
    </div>
    <div class="columns" v-for="item, index in secondBox" :key="index">
      <div class="column">
        <b-skeleton height="200px" :animated="true"></b-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListSkeleton',
  props: {
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      firstBox: 3,
      secondBox: 3
    }
  }
}
</script>
